import React, { useEffect, useState } from 'react'
import IssueApi from '../../../../api/IssueApi'
import { EnrichedIssueEntity } from 'types/IssueEntity'
import { IssueSummary } from '../../../issues/IssueSummary'
import WarrantApi from '../../../../api/WarrantApi'
import { WarrantEntity } from 'types/WarrantEntity'
import { WarrantSummary } from '../../../warrants/WarrantSummary'
import Box from '@mui/material/Box'
import { CompanyEntity, ShareCapitalChange } from 'types/CompanyEntity'
import { useLoaderData } from 'react-router-dom'
import { SHARE_SELECT_ROUTING_PARAM } from '../CompanyShare'
import { useQuery } from '../../../../hooks/useQuery'
import { SplitSummary } from './SplitSummary'

const issueApi = new IssueApi()
const warrantApi = new WarrantApi()

const getWarrantOrIssue = async (type: 'warrant' | 'issue', id: string) => {
    if (type === 'issue') return issueApi.findByIssueId(id)

    return warrantApi.findByWarrantId(id)
}

export const EventSummaryContainer = ({
    id,
    eventType,
}: {
    id: string | null
    eventType: 'issue' | 'warrant' | 'split'
}) => {
    const query = useQuery()
    const company = useLoaderData() as CompanyEntity | null
    //const [shareCapitalChange, setShareCapitalChange] = useState<ShareCapitalChange | null>(null)
    const [issue, setIssue] = useState<EnrichedIssueEntity | null>(null)
    const [warrant, setWarrant] = useState<WarrantEntity | null>(null)
    const [isLoading, setIsLoading] = useState(false)
    const [hasError, setHasError] = useState(false)
    const selectedShare =
        company?.shares.find((i) => i.id === query.get(SHARE_SELECT_ROUTING_PARAM)) ?? company?.shares[0]
    let shareCapitalChange: ShareCapitalChange | null = null

    if (eventType === 'split' && id) {
        const splitType = id.slice(0, id.indexOf('-'))

        if (splitType === 'split') {
            const [, changeDate] = id.split('split-')
            const split = selectedShare?.splits?.find((s) => s.changeDate === changeDate)

            if (split) {
                shareCapitalChange = { ...split, type: 'split' }
            }
        }

        if (splitType === 'bonus_issue') {
            const [, changeDate] = id.split('bonus_issue-')
            const bi = selectedShare?.bonusIssues?.find((s) => s.changeDate === changeDate)

            if (bi) {
                shareCapitalChange = { ...bi, type: 'bonus issue' }
            }
        }
    }

    useEffect(() => {
        if (!id) {
            setIssue(null)
            return
        }
        setHasError(false)

        if (eventType === 'split') {
            setWarrant(null)
            setIssue(null)
            return
        }

        const timer = setTimeout(() => {
            setIsLoading(true)
        }, 200)

        getWarrantOrIssue(eventType, id)
            .then((result) => {
                clearTimeout(timer)
                setIsLoading(false)

                if (eventType === 'issue') {
                    setWarrant(null)
                    setIssue(result as EnrichedIssueEntity)
                } else {
                    setIssue(null)
                    setWarrant(result as WarrantEntity)
                }
            })
            .catch((e) => {
                console.error(e)
                setHasError(true)
            })
    }, [id, selectedShare, eventType])

    if (hasError) return null

    if (issue)
        return (
            <IssueSummary
                hasCompanyLink={false}
                hasLink
                isIssueDetailsPage={false}
                isSlim
                isLoading={isLoading}
                issue={issue}
            />
        )
    if (warrant) return <WarrantSummary hasCompanyLink={false} hasLink isSlim isLoading={isLoading} warrant={warrant} />

    if (shareCapitalChange && company && selectedShare) {
        return <SplitSummary company={company} selectedShare={selectedShare} shareCapitalChange={shareCapitalChange} />
    }

    return (
        <Box sx={{ paddingX: 2 }}>
            <p>Klicka på en händelse i grafen för att visa information.</p>
        </Box>
    )
}
